"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inject = void 0;

var _styledComponents = require("styled-components");

var _theme = require("../../../theme");

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n      color: rgba(255, 255, 255, 0);\n      cursor: wait;\n\n      &:hover {\n        box-shadow: none;\n      }\n\n      &:active,\n      &:focus {\n        box-shadow: none;\n        pointer-events: none;\n      }\n\n      &[disabled] {\n        cursor: wait;\n        color: rgba(255, 255, 255, 0);\n      }\n    "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n        &:focus,\n        &:active {\n          ", "\n          ", ";\n        }\n\n        &:focus {\n          box-shadow: ", ";\n        }\n        &:active {\n          box-shadow: none;\n        }\n      "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n        &:hover {\n          box-shadow: ", ";\n          ", ";\n        }\n      "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n        &:active {\n          ", ";\n\n          ", ";\n\n          box-shadow: ", ";\n        }\n      "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n      ", ";\n      ", ";\n\n      ", ";\n\n      background-color: rgba(255, 255, 255, 0);\n      color: ", ";\n\n      ", ";\n\n      ", ";\n      ", ";\n    "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n        &:focus {\n          box-shadow: ", ";\n        }\n\n        &:active {\n          background-position-y: 0;\n        }\n      "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n        &:hover {\n          background-position-y: -39px;\n        }\n      "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n        &:active {\n          background-position-y: -39px;\n          box-shadow: ", ";\n        }\n      "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      ", ";\n\n      ", ";\n      ", ";\n\n      color: var(--c-white);\n\n      ", ";\n\n      ", ";\n      ", ";\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n        &:focus {\n          &:after {\n            opacity: ", ";\n          }\n        }\n\n        &:active {\n          &:after {\n            opacity: ", ";\n          }\n        }\n      "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n        &:hover {\n          &:after {\n            opacity: ", ";\n          }\n        }\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        &:active {\n          &:after {\n            opacity: ", ";\n          }\n        }\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      ", ";\n      color: ", ";\n\n      &:after {\n        content: '';\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        border-radius: var(--border-radius);\n        background: ", ";\n        opacity: 0;\n        pointer-events: none;\n        transition: var(--transition);\n      }\n\n      ", "\n\n      ", ";\n      ", ";\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        border-color: var(--c-neutral);\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        border-color: var(--c-neutral);\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    background: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        border-color: var(--c-light);\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _containedBorder = function _containedBorder(_ref) {
  var disabled = _ref.disabled,
      isLoading = _ref.isLoading;
  return disabled || isLoading ? (0, _styledComponents.css)(_templateObject()) : '';
};

var _containedBackground = function _containedBackground(_ref2) {
  var disabled = _ref2.disabled,
      isLoading = _ref2.isLoading,
      intent = _ref2.intent;
  return (0, _styledComponents.css)(_templateObject2(), disabled || isLoading ? 'var(--c-light)' : "var(--g-".concat(intent, ") no-repeat, var(--c-").concat(intent, "-light)"));
};

var _outlinedBorder = function _outlinedBorder(_ref3) {
  var disabled = _ref3.disabled,
      isLoading = _ref3.isLoading;
  return disabled || isLoading ? (0, _styledComponents.css)(_templateObject3()) : '';
};

var _outlinedMobileActiveBorder = function _outlinedMobileActiveBorder(_ref4) {
  var disabled = _ref4.disabled,
      isLoading = _ref4.isLoading;
  return disabled || isLoading ? (0, _styledComponents.css)(_templateObject4()) : '';
};

var _outlinedDesktopHoverColor = function _outlinedDesktopHoverColor(_ref5) {
  var disabled = _ref5.disabled,
      isLoading = _ref5.isLoading,
      intent = _ref5.intent;

  var getColor = function getColor() {
    if (disabled) return 'var(--c-neutral)';
    if (isLoading) return 'transparent';
    return "var(--c-".concat(intent, "-light)}");
  };

  return (0, _styledComponents.css)(_templateObject5(), getColor());
};

var _outlinedActiveFocusColor = function _outlinedActiveFocusColor(_ref6) {
  var isLoading = _ref6.isLoading,
      intent = _ref6.intent;
  return (0, _styledComponents.css)(_templateObject6(), isLoading ? 'transparent' : "var(--c-".concat(intent, "-light)"));
};

var _outlinedDesktopActiveFocusBorderColor = function _outlinedDesktopActiveFocusBorderColor(_ref7) {
  var isLoading = _ref7.isLoading,
      intent = _ref7.intent;
  return (0, _styledComponents.css)(_templateObject7(), isLoading ? 'var(--c-neutral)' : "var(--c-".concat(intent, "-light)"));
};

var getAppearance = function getAppearance(_ref8) {
  var disabled = _ref8.isDisabled,
      isLoading = _ref8.isLoading,
      intent = _ref8.intent,
      _ref8$appearance = _ref8.appearance,
      appearance = _ref8$appearance === void 0 ? 'contained' : _ref8$appearance;
  return {
    text: (0, _styledComponents.css)(_templateObject8(), _theme.Mixin.Style.inputPadding(), "var(--c-".concat(intent, ")"), "var(--g-".concat(intent, "), var(--c-").concat(intent, "-light)"), _theme.Mixin.Device.mobile((0, _styledComponents.css)(_templateObject9(), disabled || isLoading ? 0 : 0.3)), _theme.Mixin.Device.desktop((0, _styledComponents.css)(_templateObject10(), disabled || isLoading ? 0 : 0.1)), _theme.Mixin.Device.desktop((0, _styledComponents.css)(_templateObject11(), disabled || isLoading ? 0 : 0.2, disabled || isLoading ? 0 : 0.3))),
    contained: (0, _styledComponents.css)(_templateObject12(), _theme.Mixin.Style.inputPadding(), _containedBorder({
      disabled: disabled,
      isLoading: isLoading
    }), _containedBackground({
      disabled: disabled,
      isLoading: isLoading,
      intent: intent
    }), _theme.Mixin.Device.mobile((0, _styledComponents.css)(_templateObject13(), "var(--s-".concat(intent, ")"))), _theme.Mixin.Device.desktop((0, _styledComponents.css)(_templateObject14())), _theme.Mixin.Device.desktop((0, _styledComponents.css)(_templateObject15(), "var(--s-".concat(intent, ")")))),
    outlined: (0, _styledComponents.css)(_templateObject16(), _theme.Mixin.Style.inputPadding(), _theme.Mixin.Style.borderAll({
      color: "var(--c-".concat(intent, ")")
    }), _outlinedBorder({
      disabled: disabled,
      isLoading: isLoading
    }), "var(--c-".concat(intent, ")"), _theme.Mixin.Device.mobile((0, _styledComponents.css)(_templateObject17(), _outlinedActiveFocusColor({
      isLoading: isLoading,
      intent: intent
    }), _outlinedMobileActiveBorder({
      disabled: disabled,
      isLoading: isLoading
    }), "var(--s-".concat(intent, ")"))), _theme.Mixin.Device.desktop((0, _styledComponents.css)(_templateObject18(), "var(--s-".concat(intent, ")"), _outlinedDesktopHoverColor({
      disabled: disabled,
      isLoading: isLoading,
      intent: intent
    }))), _theme.Mixin.Device.desktop((0, _styledComponents.css)(_templateObject19(), _outlinedDesktopActiveFocusBorderColor({
      isLoading: isLoading,
      intent: intent
    }), _outlinedActiveFocusColor({
      isLoading: isLoading,
      intent: intent
    }), "var(--s-".concat(intent, ")"))))
  }[appearance];
};

var loadingStyles = function loadingStyles(isLoading) {
  if (isLoading) {
    return (0, _styledComponents.css)(_templateObject20());
  }
};

var inject = {
  getAppearance: getAppearance,
  loadingStyles: loadingStyles
};
exports.inject = inject;